import React, { useState, useEffect } from 'react';
import {
  Main,
  Container,
  Section,
  FilterGroup,
  FilterPriority,
  FilterOpen,
  FilterClosed,
  ModalFooter,
  NavigateButton
} from './styles';
import {
  Table,
  Modal,
  Popover,
  Switch,
  Icon,
  Dropdown,
  Menu,
  message,
  Button,
  Empty
} from 'antd';
import TicketContentModal from './ticketContentModal';
import RaiseTicketModal from './raiseTicketModal';
import open from '../../images/open.png';
import solvedProblem from '../../images/solved-problem.png';
import support from '../../images/support.png';
import { ScrollContainer } from '../LandingPage/styles';
import { withTranslation } from 'react-i18next';
import { ZOHO_DESK_SUPPORT, PROBLEM_TICKET_RAISED_CONFIRMATION_MODAL, REQUEST_TICKET_RAISED_CONFIRMATION_MODAL } from './TranslationValues';
import { getTicketList, getTicketDeails } from '../../utils/services/supportAPI';
import { Row, Col } from 'antd';
import moment from "moment";

// This component will render the list of tickets at a fundamental level.
// On landing in this module, The user will view the buttons to report a 
// problem, create a new request, get help and read already existing FAQs.
// Each button will redirect to a new-ticket raising form except for the gethelp 
// and faqs.faqs will redirect to an faqs component.
// Under the buttons, all existing tickets are listed with each ticket in the form of a card.
// These tickets will have information such as status, priority and created date readily visible.
// On clicking an individual ticket a modal will pop up to show more data related to the ticket.

const NAMESPACE = [
  'ZOHO_DESK_SUPPORT',
  'PROBLEM_TICKET_RAISED_CONFIRMATION_MODAL',
  'REQUEST_TICKET_RAISED_CONFIRMATION_MODAL'
]
const PROBLEM_TICKET = 'PROBLEM_TICKET_RAISED_CONFIRMATION_MODAL'
const REQUEST_TICKET = 'REQUEST_TICKET_RAISED_CONFIRMATION_MODAL'
const ZohoDeskSupport = props => {
  const { t } = props;

  const [selectedItem, setSelectedItem] = useState(null);
  const [ticketsArray, setTicketsArray] = useState([]);
  const [ticketModalVisible, setTicketModalVisible] = useState(false); // control the state of ticket's extra information modal
  const [raiseTicketModalVisible, setRaiseTicketModalVisible] = useState(false);
  const [raiseTicketModalType, setRaiseTicketModalType] = useState('');
  const [openTickets, setOpenTickets] = useState();
  const [closedTickets, setClosedTickets] = useState(false);
  const [selectPriority, setSelectPriority] = useState('')
  const [ticketResponse, setTicketResponse] = useState(true);
  const [userpage, setuserpage] = useState(1);
  const [isScrollToTop, setIsScrollToTop] = useState(false);
  const [visible, setVisible] = useState(false);

  // a singe unique ticket panel
  const uniqueTicketPanel = [
    {
      title: '',
      dataIndex: '',
      key: 'ticket',
      render: record => (
        <>
          <div className="ticket">
            <div className="ticketInfo">
              <div className="number">{`${t(ZOHO_DESK_SUPPORT.UNIQUE_TICKET_PANEL_TITLE.key, ZOHO_DESK_SUPPORT.UNIQUE_TICKET_PANEL_TITLE.value)} #${record.ticketNumber
                }`}</div>
              <div className="subject">{record.subject}</div>
            </div>
            <div className="ticketStatus">
              <img
                src={record.status === 'Closed' ? solvedProblem : open}
                alt="ticket status"
              />
            </div>
            <div className="ticketCreatedDate">
              <div>{moment(record.createdOn).format('ll')}</div>
            </div>
            <div className="ticketPriority">
              <span
                className={`priority ${record.priority === 'High'
                  ? 'high'
                  : record.priority === 'Medium'
                    ? 'medium'
                    : 'low'
                  }`}
              >
                {record.priority === 'High'
                  ? t(ZOHO_DESK_SUPPORT.HIGH_PRIORITY_TICKET_STAMP_LABEL.key, ZOHO_DESK_SUPPORT.HIGH_PRIORITY_TICKET_STAMP_LABEL.value)
                  : record.priority === 'Medium'
                    ? t(ZOHO_DESK_SUPPORT.MEDIUM_PRIORITY_TICKET_STAMP_LABEL.key, ZOHO_DESK_SUPPORT.MEDIUM_PRIORITY_TICKET_STAMP_LABEL.value)
                    : t(ZOHO_DESK_SUPPORT.LOW_PRIORITY_TICKET_STAMP_LABEL.key, ZOHO_DESK_SUPPORT.LOW_PRIORITY_TICKET_STAMP_LABEL.value)}
              </span>
            </div>
          </div>
        </>
      ),
    },
  ];

  // tickets filter priority dropdown
  const preorityDropdown = (
    <Menu>
      <Menu.Item onClick={() => handleTicketPriorityList("High")}>
        <span>{t(ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_HIGH_OPTION.key, ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_HIGH_OPTION.value)}</span>
      </Menu.Item>
      <Menu.Item onClick={() => handleTicketPriorityList('Medium')}>
        <span>{t(ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_MEDIUM_OPTION.key, ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_MEDIUM_OPTION.value)}</span>
      </Menu.Item>
      <Menu.Item onClick={() => handleTicketPriorityList('Low')}>
        <span>{t(ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_LOW_OPTION.key, ZOHO_DESK_SUPPORT.PRIORITY_DROPDOWN_LOW_OPTION.value)}</span>
      </Menu.Item>
    </Menu>
  );

  // table filter
  const filters = (
    <FilterGroup>
      <Dropdown overlay={preorityDropdown} placement="bottomLeft">
        <FilterPriority>
          {selectPriority ? selectPriority : t(ZOHO_DESK_SUPPORT.TICKET_FILTER_PRIORITY_DROPDOWN_LABEL.key, ZOHO_DESK_SUPPORT.TICKET_FILTER_PRIORITY_DROPDOWN_LABEL.value)}
        </FilterPriority>
      </Dropdown>
      <FilterOpen>
        {t(ZOHO_DESK_SUPPORT.OPEN_TOGGLE_BUTTON.key, ZOHO_DESK_SUPPORT.OPEN_TOGGLE_BUTTON.value)}
        <Switch size="small" onChange={() => handleOpenTicketList()} checked={openTickets} />
      </FilterOpen>
      <FilterClosed>
        {t(ZOHO_DESK_SUPPORT.CLOSED_TOGGLE_BUTTON.key, ZOHO_DESK_SUPPORT.CLOSED_TOGGLE_BUTTON.value)}
        <Switch size="small" onChange={() => handleClosedTicketList()} checked={closedTickets} />
      </FilterClosed>
      <FilterClosed>
        <button className='ant-btn clear-btn' onClick={() => { fetchTicketList({ pageNumber: 1 }, 'filter') }}>  <span>{t(ZOHO_DESK_SUPPORT.CLEAR_ALL_LABEL.key, ZOHO_DESK_SUPPORT.CLEAR_ALL_LABEL.value)} </span></button>
      </FilterClosed>

    </FilterGroup>
  );

  // Get single ticket details
  const handleRowClick = async (record) => {
    const response = await getTicketDeails(record.ticketId);
    if (response?.statusCode === 2120) {
      setSelectedItem(response.data);
      setTicketModalVisible(true);
    } else {
      message.error(t(ZOHO_DESK_SUPPORT.SOMETHING_WRONG_ERROR_MESSAGE.key, ZOHO_DESK_SUPPORT.SOMETHING_WRONG_ERROR_MESSAGE.value));
    }
  };

  // get all ticket list
  const fetchTicketList = async (data, type) => {
    setTicketResponse(true);
    const ticketList = await getTicketList(data);
    setTicketResponse(false);
    if (ticketList?.statusCode === 2105) {
      if (type === "filter") {
        setTicketsArray(ticketList.data);
        setuserpage(1);
      } else {
        setTicketsArray([...ticketsArray, ...ticketList.data]);
      }

      setTicketResponse(false);
    } else {
      message.error(t(ZOHO_DESK_SUPPORT.SOMETHING_WRONG_ERROR_MESSAGE.key, ZOHO_DESK_SUPPORT.SOMETHING_WRONG_ERROR_MESSAGE.value));
    }
  };

  // will filter and list out ticket panels with open status
  const handleOpenTicketList = async () => {
    setOpenTickets(!openTickets);
    setClosedTickets(false);
    const sort = {
      status: !openTickets ? 'Open' : null,
      priority: selectPriority,
      pageNumber: 1
    };
    smoothScroll();
    fetchTicketList(sort, 'filter');
  };

  // will filter and list out ticket panels with closed status
  const handleClosedTicketList = async () => {
    setClosedTickets(!closedTickets);
    setOpenTickets(false);

    const sort = {
      status: !closedTickets ? "Closed" : null,
      priority: selectPriority,
      pageNumber: 1
    };
    smoothScroll();
    fetchTicketList(sort, 'filter');
  };

  // will filter and list out ticket panels with chosen priority
  const handleTicketPriorityList = async (e) => {
    setSelectPriority(e);
    const sort = {
      status: openTickets ? 'Open' : closedTickets ? "Closed" : null,
      priority: e,
      pageNumber: 1
    }
    smoothScroll();
    fetchTicketList(sort, 'filter');
  };

  //function to open and close the request ticket modal
  const handleRaiseTicketModal = e => {
    setRaiseTicketModalType(e.target.innerText);
    setRaiseTicketModalVisible(true);
  };
  const handleRaiseTicketModalOk = (type, data) => {
    setTicketsArray([data, ...ticketsArray,])
    setRaiseTicketModalVisible(false);
    info(type);
  };

  const info = submitType => {
    Modal.info({
      title: `${submitType === 'submitProblem'
        ? t(`${PROBLEM_TICKET}:${PROBLEM_TICKET_RAISED_CONFIRMATION_MODAL.RAISED_NEW_TICKET_CONFIRMATION_DESCRIPTION.key}`, PROBLEM_TICKET_RAISED_CONFIRMATION_MODAL.RAISED_NEW_TICKET_CONFIRMATION_DESCRIPTION.value)
        : t(`${REQUEST_TICKET}:${REQUEST_TICKET_RAISED_CONFIRMATION_MODAL.RAISED_NEW_TICKET_CONFIRMATION_DESCRIPTION.key}`, REQUEST_TICKET_RAISED_CONFIRMATION_MODAL.RAISED_NEW_TICKET_CONFIRMATION_DESCRIPTION.value)
        }`,
      width: '570px',
      onOk() { },
    });

    setTimeout(() => {
      Modal.destroyAll();
    }, 3000);

  };

  const handleRaiseTicketModalCancel = () => {
    setRaiseTicketModalVisible(false);
  };

  //function to open and close the ticket's extra information modal
  const handleTicketsModalOk = () => {
    setTicketModalVisible(false);
  };

  const handleTicketsModalCancel = () => {
    setTicketModalVisible(false);
  };

  useEffect(() => {

    async function fetchData() {
      const data = {
        pageNumber: userpage
      }
      const response = await fetchTicketList(data, 'allList');
      // ...
    }
    fetchData();
  }, []);

  const handleScroll = () => {
    setVisible(false)
    if (document.querySelector('#scrollContainer').classList.contains('on-scrollbar') === false) {
      document.querySelector('#scrollContainer').classList.add('on-scrollbar');
    } else {
      setTimeout(() => {
        if (document.querySelector('#scrollContainer')) {
          document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
        }
      }, 500);
    }
    let reference = document.querySelector('#scrollContainer');
    if (
      reference.scrollTop !== 0 &&
      Math.abs(reference.scrollHeight - reference.scrollTop - reference.clientHeight) <= 1
    ) {
      setuserpage(userpage + 1);
      const data = {
        pageNumber: userpage + 1,
        priority: selectPriority,
        status: openTickets ? 'Open' : closedTickets ? "Closed" : null
      }
      fetchTicketList(data, 'allList');
    }
    if (userpage > 5) {
      setIsScrollToTop(true);
    } else {
      setIsScrollToTop(false);
    }
  };

  const smoothScroll = () => {
    document.querySelector('#scrollContainer').scrollTop = 0;
  };

  const handleWidget = () => {
    window.ZohoHCAsap && window.ZohoHCAsap.Action("open")
  }

  const handlePopoverClick = () => {
    visible && setVisible(!visible);
  };

  return (
    <>
      <Main>
        <ScrollContainer onScroll={handlePopoverClick}>
          <Container>
            <div className="pageTitle">
              <span>{t(ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_NORMAL_TITLE.key, ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_NORMAL_TITLE.value)}</span>
              <strong>{t(ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_STRONG_TITLE.key, ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_STRONG_TITLE.value)}</strong>
              <img src={support} alt="support" />
            </div>
            <div className="pageSuggetion">
              <div className="lead">{t(ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_QUESTION_DESCRIPTION.key, ZOHO_DESK_SUPPORT.ZOHO_DESK_SUPPORT_QUESTION_DESCRIPTION.value)}</div>
              <div className="base">{t(ZOHO_DESK_SUPPORT.SUGGESTIVE_ZOHO_DESK_SUPPORT_DESCRIPTION.key, ZOHO_DESK_SUPPORT.SUGGESTIVE_ZOHO_DESK_SUPPORT_DESCRIPTION.value)}</div>
            </div>
            <div className="pageDirectors">
              <Row gutter={[24, 24]} wrap={true} justify='center' align="middle">
                <Col xs={24} sm={12} md={12} lg={6} xl={6} align="middle" justify="center">
                  <NavigateButton onClick={handleRaiseTicketModal}>
                    <button data-hover={t(ZOHO_DESK_SUPPORT.RAISE_PROBLEM_SUPPORT_TICKET_BUTTON.key, ZOHO_DESK_SUPPORT.RAISE_PROBLEM_SUPPORT_TICKET_BUTTON.value)}><div>
                      {t(ZOHO_DESK_SUPPORT.RAISE_PROBLEM_SUPPORT_TICKET_BUTTON.key, ZOHO_DESK_SUPPORT.RAISE_PROBLEM_SUPPORT_TICKET_BUTTON.value)}
                    </div></button>
                  </NavigateButton>
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6} align="middle" justify="center">
                  <NavigateButton onClick={handleRaiseTicketModal}>
                    <button data-hover={t(ZOHO_DESK_SUPPORT.RAISE_REQUEST_SUPPORT_TICKET_BUTTON.key, ZOHO_DESK_SUPPORT.RAISE_REQUEST_SUPPORT_TICKET_BUTTON.value)}><div>
                      {t(ZOHO_DESK_SUPPORT.RAISE_REQUEST_SUPPORT_TICKET_BUTTON.key, ZOHO_DESK_SUPPORT.RAISE_REQUEST_SUPPORT_TICKET_BUTTON.value)}
                    </div></button>
                  </NavigateButton>
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6} align="middle" justify="center">
                  <NavigateButton onClick={() => handleWidget()}>
                    <button data-hover={t(ZOHO_DESK_SUPPORT.GET_HELP_BUTTON.key, ZOHO_DESK_SUPPORT.GET_HELP_BUTTON.value)} ><div>
                      {t(ZOHO_DESK_SUPPORT.GET_HELP_BUTTON.key, ZOHO_DESK_SUPPORT.GET_HELP_BUTTON.value)}
                    </div></button>
                  </NavigateButton>
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6} align="middle" justify="center">
                  <NavigateButton>
                    <button data-hover={t(ZOHO_DESK_SUPPORT.SUPPORT_FAQS_BUTTON.key, ZOHO_DESK_SUPPORT.SUPPORT_FAQS_BUTTON.value)}><div>
                      {t(ZOHO_DESK_SUPPORT.SUPPORT_FAQS_BUTTON.key, ZOHO_DESK_SUPPORT.SUPPORT_FAQS_BUTTON.value)}
                    </div></button>
                  </NavigateButton>
                </Col>
              </Row>
            </div>

            <Section className="allTicketsSection">
              <div className="ticketList">
                <div className="ticketListCardTitle">
                  <div></div>
                  <div className="filters">
                    <Popover visible={visible}
                      onVisibleChange={(newVisible) => setVisible(newVisible)}
                      placement="bottomRight" content={filters} trigger="click">
                      <Icon className="filterIcon" type="filter" />
                    </Popover>
                  </div>
                </div>
                <ScrollContainer
                  table
                  onScroll={handleScroll}
                  id="scrollContainer">
                  <Table
                                        pagination={false}
                    rowKey={obj => obj.ticketId}
                    loading={ticketResponse}
                    dataSource={ticketsArray}
                    columns={uniqueTicketPanel}
                    onRow={(record, rowIndex) => ({
                      onClick: () => handleRowClick(record),
                    })}
                    className="ticketsTable"
                    locale={{ emptyText: <Empty description={t(ZOHO_DESK_SUPPORT.EMPTY_TABLE_DESCRIPTION.key, ZOHO_DESK_SUPPORT.EMPTY_TABLE_DESCRIPTION.value)} /> }}
                  />
                  <Modal
                    maskClosable={false}
                    visible={ticketModalVisible}
                    onOk={handleTicketsModalOk}
                    onCancel={handleTicketsModalCancel}
                    width={1100}
                    title=" "
                    bodyStyle={{ position: 'relative', background: '#f1f1f1', zIndex: '1' }}
                    footer={[
                      <ModalFooter />,
                    ]}
                  >
                    <TicketContentModal
                      selectedItem={selectedItem}
                      setTicketModalVisible={setTicketModalVisible}
                      key={ticketModalVisible}
                    />
                  </Modal>
                </ScrollContainer>
              </div>
            </Section>
          </Container>
        </ScrollContainer>
      </Main>
      <Modal
        maskClosable={false}
        className="raiseTicketModal"
        visible={raiseTicketModalVisible}
        onOk={handleRaiseTicketModalOk}
        onCancel={handleRaiseTicketModalCancel}
        width={1000}
        footer={[]}
      >
        <RaiseTicketModal
          onSubmit={handleRaiseTicketModalOk}
          raiseTicketModalType={raiseTicketModalType}
          key={raiseTicketModalVisible}
        />
      </Modal>
    </>
  );
};

export default withTranslation(NAMESPACE)(ZohoDeskSupport);
